import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import SelectField from '../../molecules/fields/SelectField'
import TextField from '../../molecules/fields/TextField'
import WhenFieldChanges from '../../molecules/WhenFieldChanges'
import { HtmlField } from '../../molecules/fields/HtmlField'
import { Button } from '../../atoms/Button'
import * as validations from '../../../utils/validations'
import * as validationsAdmin from '../../../utils/validationsAdmin'
import { dataToOptions } from '../../../utils/helpers'
import { answerStates, changeStateMessage, stateCodes } from '../../../configs/answerConfig'
import AnswerChangeStateDescription from './AnswerChangeStateDescription'

const validationRequired = required => (required ? validationsAdmin.isRichTextFieldEmpty() : () => {})

const initialValues = {
  status: {
    label: '',
    comment: null
  }
}

const AnswerChangeState = ({ answer, onSubmit }) => {
  const answerStatusOptions = dataToOptions(answerStates).filter(option => option.value !== stateCodes.new)
  const [stateValue, setStateValue] = useState('')
  const stateMessage = changeStateMessage[stateValue]

  const handleLabelChange = (value, form) => {
    setStateValue(value)
    form.resetFieldState('status.comment')
    form.resetFieldState('status.citizen_comment')
  }

  const handleSubmit = async (values, form) => {
    await onSubmit(values)
    form.reset()
    setStateValue('')
  }

  return (
    <Form
      onSubmit={handleSubmit}
      subscription={{ pristine: true, submitting: true, values: true }}
      initialValues={initialValues}
    >
      {({ handleSubmit, submitting, pristine, form }) => (
        <form onSubmit={values => handleSubmit(values, form)}>
          <SelectField
            name="status.label"
            label="Cambiar estado:"
            options={answerStatusOptions}
            onChange={value => handleLabelChange(value, form)}
          />
          <WhenFieldChanges field="status.label" set="status.comment" to={null} />
          <WhenFieldChanges field="status.label" set="status.citizen_comment" to={null} />
          {stateMessage && (
            <>
              <AnswerChangeStateDescription formIsTrackable={answer.form.is_trackable} stateMessage={stateMessage} />
              <TextField
                name="status.comment"
                element="textarea"
                validate={validations.required()}
                className="sm:max-w-none h-40 rounded-lg"
                rootClassName="text-sm"
                label="Notificación para control interno"
                rows={4}
                size="full"
                placeholder="Este mensaje será visible solo para los usuarios de tu entidad y se guardará como parte del historial interno. No será mostrado al ciudadano."
              />
              {answer.form.is_trackable && (
                <HtmlField
                  key={stateValue}
                  name="status.citizen_comment"
                  label="Mensaje para el ciudadano"
                  validate={validationRequired(stateMessage.citizenMessageRequired)}
                  placeholder={stateMessage.citizenMessage}
                  className="text-sm"
                  maxContentLength={750}
                  borderRounded
                />
              )}
              <div className="flex justify-end">
                <Button type="submit" disabled={pristine || submitting}>
                  Actualizar estado
                </Button>
              </div>
            </>
          )}
        </form>
      )}
    </Form>
  )
}

export default AnswerChangeState

AnswerChangeState.propTypes = {
  answer: PropTypes.object,
  onSubmit: PropTypes.func
}
